<!-- <app-module-header [title]="organization.organizationName + ' - ' + ('PLACEHOLDER.INTERNAL_BOOKING' | transloco) + ' ' + ('PLACEHOLDER.TRAVEL_AGENT' | transloco)" [icon]="'loyalty'"></app-module-header> -->

<div class="container p-0" #top>
  <form [formGroup]="bookingForm">

    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">loyalty</mat-icon>{{ 'PLACEHOLDER.TRAVEL_AGENT' | transloco }}
    </mat-toolbar>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'PLACEHOLDER.TRAVEL_AGENT_BUNDLE' | transloco }}</mat-label>
      <mat-select (selectionChange)="getTravelAgencyBundle($event)" formControlName="travelAgency">
        @for (bundle of productOption; track bundle) {
          <mat-option [value]="bundle.value">
            <div class="option-flex-container">
              <span class="font-weight-bold mr-2">
                {{bundle.viewValue}}
              </span>
              <div class="spacer"></div>
              <span class="font-weight-light">
                {{bundle.price}} SEK
              </span>
            </div>
          </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix>loyalty</mat-icon>
      @if (!bookingForm.controls.travelAgency.valid &&
        bookingForm.controls.travelAgency.touched) {
        <mat-error>
          {{ 'ERROR.SELECT_BUNDLE' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <app-text-input [formControl]='bookingForm.controls["email"]' [type]="'email'" [label]="'Email'"
      [placeholder]="'PLACEHOLDER.EMAIL' | transloco" [icon]="'email'">
    </app-text-input>

    <!--START NEW-->
    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">flight_takeoff</mat-icon>{{ 'PLACEHOLDER.DEPARTURE' | transloco }}
    </mat-toolbar>

    <mat-form-field appearance="outline" (click)="picker.open()">
      <mat-label>{{ 'FORM.DEPARTURE_DATE' | transloco }}</mat-label>
      <input matInput [min]="minDepartureDate" [matDatepicker]="picker" formControlName="flightDepartureDate"
        (dateChange)="getFlightsByDate($event, 'departure');">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #picker></mat-datepicker>
      @if (!bookingForm.controls.flightDepartureDate.valid &&
        bookingForm.controls.flightDepartureDate.touched) {
        <mat-error>
          {{ 'ERROR.DEPARTURE_FLIGHTNUMBER' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      @if (isLoadingDeparture) {
        <mat-label>{{ 'FORM.FETCH_FLIGHTS' | transloco }}</mat-label>
      }
      @if (!isLoadingDeparture) {
        <mat-label>{{ 'FORM.FLIGHT_NUMBER' | transloco }}</mat-label>
      }
      <input matInput type="text" placeholder="{{ 'PLACEHOLDER.SEARCH_FLIGHT' | transloco }}" aria-label="Number"
        formControlName="flightDepartureNumber" [matAutocomplete]="autoDepartures"
        (input)="onDepartureNumberChange($event.target.value)">
      <mat-autocomplete #autoDepartures="matAutocomplete">
        @for (departFlight of filteredOptionsFlightsDepartures | async; track departFlight) {
          <mat-option
            [value]="departFlight.flightId" (onSelectionChange)="onDepartureSelect($event)"
            [disabled]="departFlight.locationAndStatus?.flightLegStatus === 'DEL' || departFlight.locationAndStatus?.flightLegStatus === 'Deleted'">
            <div class="option-flex-container"
              [ngClass]="{'text-decoration-line-through': departFlight.locationAndStatus?.flightLegStatus === 'DEL' || departFlight.locationAndStatus?.flightLegStatus === 'Deleted'}">
              <span class="font-weight-bold mr-2">
                {{departFlight.flightId}}
              </span>
              @if (translate.getActiveLang() === 'sv') {
                <span
                class="font-weight-light">{{departFlight.arrivalAirportSwedish}}</span>
              }
              @if (translate.getActiveLang() === 'en') {
                <span
                class="font-weight-light">{{departFlight.arrivalAirportEnglish}}</span>
              }
              <div class="spacer"></div>
              <span class="font-weight-light">&nbsp;{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
                {{departFlight.departureTime.scheduled | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
      @if (isLoadingDeparture) {
        <mat-spinner matSuffix color="accent" diameter="20">
        </mat-spinner>
      }
      @if (!isLoadingDeparture) {
        <mat-icon matSuffix>flight_takeoff</mat-icon>
      }
      @if (!bookingForm.controls.flightDepartureNumber.valid && bookingForm.controls.flightDepartureNumber.touched) {
        <mat-error
          >
          {{ 'ERROR.DEPARTURE_FLIGHTNUMBER' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    @if (selectedFlight==null) {
      <span class="mat-error">
        {{ 'ERROR.DEPARTURE_FLIGHTNUMBER' | transloco }}
      </span>
    }

    <mat-form-field appearance="outline">
      <mat-label>{{ 'FORM.ARRIVAL_TIME' | transloco }}</mat-label>
      <mat-select (selectionChange)="getParkingTime($event)" formControlName="parkingfrom"
        [disabled]="selectedFlight==null">
        <mat-option [value]="this.arriveAtParking270Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.4.5_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking270Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking255Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.4.25_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking255Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking240Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.4_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking240Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking225Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.3.75_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking225Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking210Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.3.5_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking210Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking195Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.3.25_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking195Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking180Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.3_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking180Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking165Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.2.75_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking165Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking150Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.2.5_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking150Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking135Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.2.25_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking135Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking120Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.2_HOURS_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking120Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking105Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.1.75_HOUR_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking105Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking90Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.1.5_HOUR_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking90Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking75Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.1.25_HOUR_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking75Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
        <mat-option [value]="this.arriveAtParking60Min">
          <div class="option-flex-container">
            <span class="mr-2">
              {{ 'PLACEHOLDER.1_HOUR_BEFORE' | transloco }}
            </span>
            <div class="spacer"></div>
            <span class="font-weight-light">{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
              {{this.arriveAtParking60Min | date: 'HH:mm'}}
            </span>
          </div>
        </mat-option>
      </mat-select>
      <mat-icon matSuffix>schedule</mat-icon>
      @if (!bookingForm.controls.parkingfrom.valid &&
        bookingForm.controls.parkingfrom.touched) {
        <mat-error>
          {{ 'ERROR.SELECT_PARKING_FROM' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">flight_land</mat-icon>{{ 'PLACEHOLDER.ARRIVAL' | transloco }}
    </mat-toolbar>

    <mat-form-field appearance="outline" (click)="picker1.open()">
      <mat-label>{{ 'FORM.ARRIVAL_DATE' | transloco }}</mat-label>
      <input matInput [min]="minArrivalDate" [matDatepicker]="picker1" formControlName="flightArrivalDate"
        (dateChange)="getFlightsByDate($event, 'arrival');">
      <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
      <mat-datepicker touchUi #picker1></mat-datepicker>
      @if (!bookingForm.controls.flightArrivalDate.valid &&
        bookingForm.controls.flightArrivalDate.touched) {
        <mat-error>
          {{ 'ERROR.DATE' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline">
      @if (isLoadingArrival) {
        <mat-label>{{ 'FORM.FETCH_FLIGHTS' | transloco }}</mat-label>
      }
      @if (!isLoadingArrival) {
        <mat-label>{{ 'FORM.ARRIVAL_FLIGHTNUMBER' | transloco }}</mat-label>
      }
      <input matInput type="text" placeholder="{{ 'PLACEHOLDER.SEARCH_FLIGHT' | transloco }}" aria-label="Number"
        formControlName="flightArrivalNumber" [matAutocomplete]="autoArrivals"
        (input)="  ($event.target.value)">
      <mat-autocomplete #autoArrivals="matAutocomplete" [displayWith]="displayArrivalFlightWrapper()">
        @for (arrivalFlight of filteredOptionsFlightsArrivals | async; track arrivalFlight) {
          <mat-option [value]="arrivalFlight"
            [disabled]="arrivalFlight.locationAndStatus?.flightLegStatus === 'DEL' || arrivalFlight.locationAndStatus?.flightLegStatus === 'Deleted'"
            (onSelectionChange)="onArrivalSelect($event)">
            <div class="option-flex-container"
              [ngClass]="{'text-decoration-line-through': arrivalFlight.locationAndStatus?.flightLegStatus === 'DEL' || arrivalFlight.locationAndStatus?.flightLegStatus === 'Deleted'}">
              <span class="font-weight-bold mr-2">
                {{arrivalFlight.flightId}}
              </span>
              @if (translate.getActiveLang() === 'sv') {
                <span
                class="font-weight-light">{{arrivalFlight.departureAirportSwedish}}</span>
              }
              @if (translate.getActiveLang() === 'en') {
                <span
                class="font-weight-light">{{arrivalFlight.departureAirportEnglish}}</span>
              }
              <div class="spacer"></div>
              <span class="font-weight-light">&nbsp;{{("PARKIFLY.CLOCK_SHORT" | transloco) + ": "}}
                {{arrivalFlight.arrivalTime.scheduled | date: 'HH:mm'}}
              </span>
            </div>
          </mat-option>
        }
      </mat-autocomplete>
      @if (isLoadingArrival) {
        <mat-spinner matSuffix color="accent" diameter="20">
        </mat-spinner>
      }
      @if (!isLoadingArrival) {
        <mat-icon matSuffix>flight_land</mat-icon>
      }
    </mat-form-field>

    @if ((bookingForm.controls.flightArrivalNumber.dirty || bookingForm.controls.flightArrivalNumber.touched) && bookingForm.controls.flightArrivalId.invalid && bookingForm.controls.flightArrivalId.errors.required) {
      <span class="mat-error"
        >
        {{ 'ERROR.ARRIVAL_FLIGHTNUMBER' | transloco }}
      </span>
    }

    @if (!hasAvailableParking) {
      <mat-toolbar color="accent" class="mb-4 mat-elevation-z8 animate__animated animate__bounce"
        >
        Inga lediga platser lediga för vald period
      </mat-toolbar>
    }

    <mat-toolbar class="my-4 mat-elevation-z8" color="primary">
      <mat-icon class="mr-3">directions_car</mat-icon>{{ 'FORM.CAR_PERSON' | transloco }}
    </mat-toolbar>

    <mat-form-field appearance="outline">
      <mat-label>{{ 'FORM.CARID' | transloco }}</mat-label>
      <input matInput placeholder="{{ 'PLACEHOLDER.CARID' | transloco }}"
        oninput="this.value = this.value.toUpperCase()" formControlName="carid">
      <mat-icon matSuffix>directions_car</mat-icon>
      @if (!bookingForm.controls.carid.valid &&
        bookingForm.controls.carid.touched) {
        <mat-error>
          {{ 'ERROR.CARID' | transloco }}
        </mat-error>
      }
    </mat-form-field>

    <app-text-input [formControl]='bookingForm.controls["firstname"]' [label]="'FORM.FIRST_NAME' | transloco"
      [placeholder]="'PLACEHOLDER.FIRST_NAME' | transloco" [icon]="'account_box'">
    </app-text-input>

    <app-text-input [formControl]='bookingForm.controls["lastname"]' [label]="'FORM.LAST_NAME' | transloco"
      [placeholder]="'PLACEHOLDER.LAST_NAME' | transloco" [icon]="'account_box'">
    </app-text-input>

    <app-text-input [formControl]='bookingForm.controls["cellular"]' [type]="'tel'"
      [label]="'FORM.PHONENUMBER' | transloco" [placeholder]="'PLACEHOLDER.PHONENUMBER' | transloco"
      [icon]="'smartphone'">
    </app-text-input>

    <app-select-input [formControl]='bookingForm.controls["persons"]' [label]="'FORM.PERSONS' | transloco"
      [icon]="'people'" [items]="persons">
    </app-select-input>

    <mat-checkbox formControlName="onlyHandBaggage" (change)="checkBaggage($event)" class="checkbox-margin-bottom">
      <span class="font-weight-light">{{
        'FORM.ONLY_HANDBAGGAGE' | transloco }}
      </span>
    </mat-checkbox>

    <app-textarea-input [formControl]='bookingForm.controls["comment"]' [label]="'FORM.COMMENT' | transloco"
      [placeholder]="'PLACEHOLDER.OPTIONAL_INFO' | transloco">
    </app-textarea-input>

    <mat-checkbox formControlName="overrideParking" (change)="checkOverrideParking($event)">
      <span class="font-weight-light">{{ 'PLACEHOLDER.OVER_BOOKING' | transloco }}</span>
    </mat-checkbox>
  </form>

  <div class="form-actions-container">
    <button mat-raised-button color="warn" type="button" class="mt-2" (click)="resetForm()" class="action-button-width">{{
      'FORM.CLEAR' |
      transloco | uppercase}}
    </button>
    <button mat-raised-button type="button" class="success-button my-2 mt-2 action-button-width"
      (click)="openBottomSheet()"
      [disabled]="bookingForm.status === 'INVALID' || isLoading || !hasAvailableParking">
      @if (isLoading) {
        <mat-icon class="spinner-icon">
          <mat-spinner color="accent" diameter="20">
          </mat-spinner>
        </mat-icon>
        }{{ 'FORM.CONTINUE' | transloco | uppercase}}
      </button>
    </div>

    <app-small-footer></app-small-footer>
  </div>